import {axiosUtil} from "../../../utils/axios_util";

const templateApi = {

    //模版管理分页查询
    getTemplatePage(data:powerSearchData) {
        return axiosUtil({
            url: '/calling/card/template/query',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },

    //模板添加
    templateAdd(data:any) {
        return axiosUtil({
            url: `/calling/card/template/add`,
            method: 'post',
            data,
        })
    },

    //模板修改
    templateUpdate(data:any) {
        return axiosUtil({
            url: `/calling/card/template/update`,
            method: 'post',
            data,
        })
    },

    //获取一条数据
    templateGetOne(noId: string) {
        return axiosUtil({
            url: `/calling/card/signature/getOne/${noId}`,
            method: 'POST',
        })
    },

    //删除
    templateDelete(noId: string) {
        return axiosUtil({
            url: `/calling/card/template/delete/${noId}`,
            method: 'POST',
        })
    },

    //启用
    templateStart(noId: string) {
        return axiosUtil({
            url: `/calling/card/template/start?noId=${noId}`,
            method: 'POST',
        })
    },

    //禁用
    templateForbidden(noId: string) {
        return axiosUtil({
            url: `/calling/card/template/forbidden?noId=${noId}`,
            method: 'POST',
        })
    },

    //获取临时上传地址
    temporaryUpload(fileName: string) {
        return axiosUtil({
            url: `/calling/card/template/temporaryUpload?fileName=${fileName}`,
            method: 'POST',
        })
    },

    //获取临时下载地址
    temporaryDown(fileName: string) {
        return axiosUtil({
            url: `/calling/card/template/temporaryDown?objectsName=${fileName}`,
            method: 'POST',
        })
    },
}

export default templateApi
